import {
  PB_SERVICE_LIST_GET_SELECTED_SERVICE_BEGIN,
  PB_SERVICE_LIST_GET_SELECTED_SERVICE_DISMISS_ERROR,
  PB_SERVICE_LIST_GET_SELECTED_SERVICE_FAILURE,
  PB_SERVICE_LIST_GET_SELECTED_SERVICE_SUCCESS,
} from './constants';

import CommonService from '../../../../services/commonService';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getSelectedService(args = {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PB_SERVICE_LIST_GET_SELECTED_SERVICE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(args.url, {
        headers: CommonService.getHeaders(),
        cancelToken: args.cancelToken,
      });
      doRequest.then(
        res => {
          // console.log('testing raw response from get Selected service---', res);
          // console.log('CommonService.makeServiceDetailsApi(res.data.body) ', CommonService.makeServiceDetailsApi(res.data.body))
          dispatch({
            type: PB_SERVICE_LIST_GET_SELECTED_SERVICE_SUCCESS,
            data:
              res.data.body && res.data.body.id
                ? CommonService.makeServiceDetailsApi(res.data.body)
                : null,
          });
          resolve(
            res.data.body && res.data.body.id
              ? CommonService.makeServiceDetailsApi(res.data.body)
              : { error: res.data.body },
          );
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: PB_SERVICE_LIST_GET_SELECTED_SERVICE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetSelectedServiceError() {
  return {
    type: PB_SERVICE_LIST_GET_SELECTED_SERVICE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PB_SERVICE_LIST_GET_SELECTED_SERVICE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSelectedServicePending: true,
        getSelectedServiceError: null,
      };

    case PB_SERVICE_LIST_GET_SELECTED_SERVICE_SUCCESS:
      // The request is success
      return {
        ...state,
        getSelectedServicePending: false,
        getSelectedServiceError: null,
        selectedService: action.data,
      };

    case PB_SERVICE_LIST_GET_SELECTED_SERVICE_FAILURE:
      // The request is failed
      return {
        ...state,
        getSelectedServicePending: false,
        getSelectedServiceError: action.data.error,
      };

    case PB_SERVICE_LIST_GET_SELECTED_SERVICE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSelectedServiceError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/redux/getSelectedService.js